import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { toggleWithLoadUpdateReservationModal } from '../../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { loadSearch } from '../../../../../actions/search/loadSearch'
import { IEvent } from '../../../../../models/Event'
import { IStore } from '../../../../../reducers'
import {
  isSearchLoading,
  isSearchReady,
} from '../../../../../reducers/search/selectors/search'
import getDrawerRef from '../../../../../reducers/search/selectors/getDrawerRef'
import { searchEvents } from '../../../../../reducers/bookingCalendar/selectors/search'
import Search, { ISearchDispatchProps, ISearchStateProps } from './Search'

const mapStateToProps = (state: IStore): ISearchStateProps => {
  return {
    drawerRef: getDrawerRef(state),
    isLoading: isSearchLoading(state),
    isReady: isSearchReady(state),
    searchEvents: searchEvents(state),
  }
}

const bindDispatchToProps = (dispatch: Dispatch): ISearchDispatchProps => ({
  loadSearch: () => dispatch(loadSearch()),
  updateEvent: (id: IEvent['id']) =>
    dispatch(toggleWithLoadUpdateReservationModal(id, true)),
})

export default connect<ISearchStateProps, ISearchDispatchProps, any>(
  mapStateToProps,
  bindDispatchToProps,
)(Search)
